import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { SPORT_PAGES } from '@/data/sportPages';

const TAGLINE = 'Your League. One Platform.';
const linkCls = 'hover:text-white transition-colors';

const Col = ({ title, children, testId }) => (
  <div data-testid={testId}>
    <h4 className="font-semibold mb-4">{title}</h4>
    <ul className="space-y-2 text-sm text-slate-400">{children}</ul>
  </div>
);

export const SiteFooter = () => {
  const { isAuthenticated, logout } = useAuth();
  return (
    <footer className="bg-slate-900 text-white py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/"><img src="/logo-transparent.png" alt="Schedule Guru" className="h-12 mb-4" /></Link>
            <p className="text-sm font-semibold text-amber-300 mb-1" style={{ fontFamily: 'Barlow Condensed', letterSpacing: '0.12em' }} data-testid="footer-tagline">
              {TAGLINE.toUpperCase()}
            </p>
            <p className="text-sm text-slate-400 leading-relaxed">
              All-in-one sports league and tournament management, from your first free schedule to the championship.
            </p>
          </div>
          <Col title="Product">
            <li><Link to="/create" className={linkCls}>Create Event</Link></li>
            <li><Link to="/bracket-library" className={linkCls}>Bracket Library</Link></li>
            <li><a href="/#officials" className={linkCls}>Officials Scheduling</a></li>
            <li><Link to="/pricing" className={linkCls}>Pricing</Link></li>
            <li><Link to="/blog" className={linkCls}>Blog</Link></li>
          </Col>
          <Col title="Sports" testId="footer-sports">
            {SPORT_PAGES.map((s) => (
              <li key={s.path}><Link to={s.path} className={linkCls} data-testid={`footer-sport-${s.sport}`}>{s.label} League Software</Link></li>
            ))}
          </Col>
          <Col title="Formats">
            <li>Round Robin</li>
            <li>Double Round Robin</li>
            <li>Single Elimination</li>
            <li>Double Elimination</li>
          </Col>
          <Col title="Account">
            {isAuthenticated ? (
              <>
                <li><Link to="/my-schedules" className={linkCls}>My Schedules</Link></li>
                <li><button onClick={logout} className={linkCls}>Logout</button></li>
              </>
            ) : (
              <>
                <li><Link to="/login" className={linkCls}>Log In</Link></li>
                <li><Link to="/login?mode=register" className={linkCls}>Sign Up</Link></li>
              </>
            )}
            <li><Link to="/terms" className={linkCls}>Terms of Service</Link></li>
            <li><Link to="/privacy" className={linkCls}>Privacy Policy</Link></li>
          </Col>
        </div>
        <div className="border-t border-slate-800 pt-8 text-center text-sm text-slate-400">
          &copy; {new Date().getFullYear()} Schedule Guru — All-in-One Sports League Management Software, including a Free Round Robin Schedule Generator | by Anglin Sports Consultancy
        </div>
      </div>
    </footer>
  );
};
